module.exports = __webpack_public_path__ + "90de3ee6a49c4055748f53fb0389714e.fbx";